module.exports = __webpack_public_path__ + "img/discord-mark-white.c556bc28.svg";